import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=9fc45fa0&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fc45fa0"]])

export default __exports__